<template>
  <div class="slider-sf-alert">
    <div class="alert alert-danger" role="alert" style="min-height: 70px;">
      {{ $t('javascript.fee_changed') }}
      <a class="btn btn-danger" style="float: right;" :href="'/cases/' + caseId + '/payment'">{{ $t('javascript.review_the_service_fee') }}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "s-sf-alert",
    props: [
      'caseId'
    ]
  }
</script>
